export const SET_INVENTORY_STATUS = "SET_INVENTORY_STATUS";

export interface InventoryStatusType{
    inventoryStatus: boolean
};